
<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="customerName"
            label="Cliente"
            >
          </v-text-field>
        </v-card>
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- v-if="item.status == 1 || item.status == 2" -->
    <template slot="action6" slot-scope="{ item }" v-if="item.status==5 || item.status==3"
      >
      <BasePopup :entry="item" @delete-confirm-action="askReschedule(item)" @delete-cancel-action="cancelAskReschedule(item)"
        :modelNameSingular="'Resc'" :formErrors="formErrors" :ref="'askReschedule'+item.id" :deleteIcon="cancelIcon"
        :deleteButtonLabel="'Remarcar'" :deleteTitle="'Agenda'" :deleteColor="cancelColor" :showButton="false"
        :deleteConfirmButtonLabel="'Confirmar'">
        <p> Deseja remarcar nova visita ?</p>
        <v-form ref="form">

          <v-col cols="12" sm="12">
            <v-switch 
            v-model="reschedule" 
            inset 
            :label="reschedule ? 'Sim' : 'Não'"
            >
          </v-switch>
        </v-col>
        <v-col cols="12" sm="12" md="12" v-if="!reschedule">
          <v-textarea
          v-model="item.feedback"
          label="Motivo"
          outlined
          autocomplete="off"
          />
        </v-col>
      </v-form>
      </BasePopup>
    </template>

    <template slot="action4" slot-scope="{ item }" v-if="item.status==3">
       <Finalize
        :entry="item"
        @finalize-updated="finalizeUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="action5" slot-scope="{ item }">
       <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
        :parentId="item.id"
        :inlineAddButton="true"
        :ref="'item'+item.id"
        :addButtonIcon="'mdi-calendar-refresh-outline'"
        :isEdit="false"
        :newCreateButtonLabel="'Remarcar'"
        :showButton="item.status !=3"
      />
    </template>

    <template slot="action7" slot-scope="{ item }" v-if="item.status==3"
      >
      <BasePopup :entry="item" @delete-confirm-action="cancelAgenda(item)" @delete-cancel-action="closeAgenda(item)"
        :modelNameSingular="'Cancelar'" :formErrors="formErrors" :ref="'cancel'+item.id" :deleteIcon="'mdi-calendar-remove-outline'"
        :deleteButtonLabel="'Cancelar'" :deleteTitle="'Agenda'"
        :deleteConfirmButtonLabel="'Confirmar'">
        <p> Deseja cancelar essa agenda ?</p>
        <v-form ref="form">
        <v-col cols="12" sm="12" md="12">
          <v-textarea
          v-model="item.feedback"
          label="Motivo"
          outlined
          autocomplete="off"
          />
        </v-col>
      </v-form>
      </BasePopup>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from '@shared_components/base_index.vue';
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import BasePopup from '@shared_components/base_popup.vue';
import DateTimeField from '@shared_components/date_time_field.vue';
import Finalize from "./finalize.vue";

// import { useTemplateRef } from 'vue';

// const childRef = useTemplateRef('item');

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      testItems: {},
      reschedule: true,
      // tableHeaders: [],
      formErrors: [],
      maskFields: [
        // { field: 'price', mask: 'currency'},
        { field: 'statusText', mask: 'status_color', colorField: 'statusColor' }, 
        { field: 'predictedStartTime', mask: 'datetime' },
        { field: 'predictedEndTime', mask: 'datetime' },
        { field: 'startTime', mask: 'datetime' },
        { field: 'endTime', mask: 'datetime' },
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    customerName: {
      type: String,
      default: null,
    },
    modelNameSingular: {
      type: String,
      default: "Compromisso"
    },
    modelNamePlural: {
      type: String,
      default: "Compromissos"
    },
    cancelIcon: {
      type: String,
      default: "mdi-calendar-check",
    },
    cancelColor: {
      type: String,
      default: "success"
    },
    cancelButtonLabel: {
      type: String,
      default: function () {
        return "Finalizar";
      }
    },
    cancelTitle: {
      type: String,
      default: function () {
        return "Finalizar Agenda"
      }
    },
    cancelConfirmButtonLabel: {
      type: String,
      default: "Finalizar"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePopup: BasePopup,
    DateTimeField: DateTimeField,
    Finalize: Finalize,
  },
  mounted(){
    // console.log("mounted");
    // this.testItems = ref({});
    // console.log(this.$refs);
    // this.$refs.item.click();
  },
  created() {
    // this.loadServerEntries();
    // console.log("refs: ", this.$refs);
    // console.log("item", this.childRef);
    // console.log("base", this.$refs.baseIndex);
    // console.log("target", this.$refs['item']);
    // console.log("item: ", this.$refs.item);
    // this.$refs.items.click();
    // console.log(this.testItems);
    // if(this.testItems){
    //   console.log("tem");
    //   this.testItems.value[1].click();
    // }
  },
  watch: {
    "customerName": function(newSearch) {
      if (this.customerName && this.customerName.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Cliente", align: "left", sortable: true, value: "customerName" },
        { text: "Vendedor", align: "left", sortable: true, value: "sellerName" },
        { text: "Programado", align: "left", sortable: true, value: "predictedStartTime" },
        { text: "Realizado", align: "left", sortable: true, value: "endTime" },
        // { text: "Inicio", align: "left", sortable: true, value: "startTime" },
        { text: "Status", align: "left", sortable: false, value: "statusText" },
        { text: "Objetivo do contato", align: "left", sortable: true, value: "description" },
        { text: "Desc. Pós contato", align: "left", sortable: true, value: "afterDescription" },
        // { text: "Motivo", align: "left", sortable: true, value: "feedback" },
        // { text: "Fim programado", align: "left", sortable: true, value: "predictedEndTime" },
        ... this.$can('create', this.$router.currentRoute.name) || this.$can('update', this.$router.currentRoute.name) ? [{ text: "Ações", align: "left", sortable: false, value: "action" }] : []
      ]
    }
  },
  methods: {
    cancelAction: function () {
      if(this.$refs.baseDelete){
        this.$refs.baseDelete.closeDialog();
      }
      // if(this.$refs.askReschedule){
      //   this.$refs.askReschedule.closeDialog();
      // }
      // this.$emit('entry-canceled');
    },
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_AGENDA,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters,
              customFilters: {customer_name: this.customerName},
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.indexItems = response.data.accountContext.agendasIndex.agendaViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.agendasIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.agendasIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.agendasIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },

    
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    finalizeUpdated: function(item){
      // this.loadServerEntries();
      // this.$refs.baseIndex.showConfirmationUpdateMessage();
      console.log("fup", item);
      // console.log(this.$refs);
      // var str = "item"+entry.id;
      // console.log(str);
      console.log(this.$refs);
      this.$refs["askReschedule"+item.id].openAction();
    },
    askReschedule: function(item){
      if(this.reschedule){
        this.$refs['askReschedule'+item.id].closeDialog();
        // console.log(this.$refs);
        this.$refs["item"+item.id].$refs.baseNew.openAction();
      }else{
        // this.$refs.form.validate();
        var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(item, item.askRescheduleValidations);
        this.loading = true;
        this.$apollo
          .query({
            query: ASK_RESCHEDULE_AGENDA_MUTATION,
            variables: {
              input: filtered,
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.$refs['askReschedule'+item.id].closeDialog();
            this.loadServerEntries();
            // this.indexItems = response.data.accountContext.agendasIndex.agendas; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
            // this.totalItems = response.data.accountContext.agendasIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
            // this.typeOperators = response.data.accountContext.agendasIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
            // this.serverFields = response.data.accountContext.agendasIndex.serverFields; // seta os campos que podem ser filtrados

          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
    },
    cancelAskReschedule: function(item){
       this.$refs["askReschedule"+item.id].closeDialog();
    },
    cancelAgenda: function(item){
      // this.$refs.form.validate();
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(item, item.cancelValidations);
      this.loading = true;
      var self = this;
      this.$apollo
        .query({
          query: CANCEL_AGENDA_MUTATION,
          variables: {
            input: filtered,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          console.log("then", this.$refs);
          console.log("then2", self.$refs);
          self.$refs["askReschedule"+item.id].openAction();
          self.$refs['cancel'+item.id].closeDialog();
          // this.loadServerEntries();
          // this.indexItems = response.data.accountContext.agendasIndex.agendas; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          // this.totalItems = response.data.accountContext.agendasIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          // this.typeOperators = response.data.accountContext.agendasIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          // this.serverFields = response.data.accountContext.agendasIndex.serverFields; // seta os campos que podem ser filtrados

        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    closeAgenda: function(item){
       this.$refs["cancel"+item.id].closeDialog();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_AGENDA = gql `
  query($input: IndexInputObject!) {
    accountContext {
      agendasIndex(input: $input){
        count
        typeOperators
        serverFields      
        agendaViewIndexFilters {
          id
          description
          afterDescription
          predictedStartTime
          predictedEndTime
          startTime
          endTime
          customerName
          sellerName
          statusText
          status
          statusColor
          canBeDeleted
          undeletabilityReasons
          askRescheduleValidations
          cancelValidations
        }
      }
    }
  }
`;

const ASK_RESCHEDULE_AGENDA_MUTATION = gql `
  mutation($input: AgendaAskRescheduleInputObject!) {
    askRescheduleAgenda(input: $input) {
      agenda {
        id
      }
      errors
    }
  }
`;

const CANCEL_AGENDA_MUTATION = gql `
  mutation($input: AgendaCancelInputObject!) {
    cancelAgenda(input: $input) {
      agenda {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

